import script from "./IngresoStoreTab.vue?vue&type=script&setup=true&lang=js"
export * from "./IngresoStoreTab.vue?vue&type=script&setup=true&lang=js"

import "./IngresoStoreTab.vue?vue&type=style&index=0&id=37f2ddbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f2ddbc"]])

export default __exports__